//
export default [
    {
        text: "#",
        value: "id",
    },
    {
        text: "nombre",
        value: "name",
    },
    {
        text: "fecha de modificación",
        value: "updated_at",
        align: "right",
        format: "datetime",
    },
    {
        text: "fecha de creación",
        value: "created_at",
        align: "right",
        format: "datetime",
    },
]